export const ALERT_DIALOG_SHOW = "ALERT_DIALOG_SHOW"
export const ALERT_DIALOG_HIDE = "ALERT_DIALOG_HIDE"

export const CONFIRM_DIALOG_SHOW = "CONFIRM_DIALOG_SHOW"
export const CONFIRM_DIALOG_HIDE = "CONFIRM_DIALOG_HIDE"

export const showConfirmDialog = (
    dispatch,
    title,
    message,
    onYesAction,
    onNoAction = () => dispatch(hideConfirmDialog()),
    yesButtonLabel = "Yes",
    noButtonLabel = "No") => {
    return {
        type: CONFIRM_DIALOG_SHOW,
        options: {
            title: title,
            message: message,
            onYesAction: onYesAction,
            yesButtonLabel: yesButtonLabel || "Yes",
            noButtonLabel: noButtonLabel || "No",
            onNoAction: onNoAction
        }
    }
}
export const hideConfirmDialog = () => {
    return {
        type: CONFIRM_DIALOG_HIDE
    }
}
export const showAlertDialog = (
    dispatch,
    message,
    title = "Alert",
    okButtonLabel = "OK",
    onOkAction = () => dispatch(hideAlertDialog())) => {
    return {
        type: ALERT_DIALOG_SHOW,
        options: {
            title: title,
            message: message,
            okButtonLabel: okButtonLabel || "OK",
            onOkAction: onOkAction
        }
    }
}
export const hideAlertDialog = () => {
    return {
        type: ALERT_DIALOG_HIDE
    }
}


// WEBPACK FOOTER //
// ./src/common/actions/common-actions.js